import { css } from 'linaria';
import { MediaQueries } from 'utils/internal-specifics/media-queries';

export const variantDrawer = css`
  --drawerWidth: 600px !important;
  ${MediaQueries.mediaMobile} {
    --drawerWidth: 100% !important;
  }
  [data-testid='drawer-content-wrapper'] {
    height: 100vh;
    height: 100dvh;
  }
`;

export const drawerScroll = css`
  overflow-y: scroll;
`;

export const drawerHeaderPadding = css`
  padding-top: var(--space-200);
  padding-bottom: var(--space-200);
`;

export const multiDropdown = css`
  opacity: 1 !important;
  span {
    color: var(--text-primary) !important;
    background-color: var(--background-primary) !important;
  }
  svg {
    opacity: 0.4;
  }
`;
